export interface MenuItem {
   label: string;
   icon?: string;
   route?: string;
   queryParams?: any;
   isExternal?: boolean;
   isPublic?: boolean;
   isGuarded?: boolean;
   children?: MenuItem[];
   type?: 'link' | 'collapse' | 'dynamic-portfolio' | 'section';
   mobileOnly?: boolean;
   id?: string;
   action?: () => void;
   hideExternalIcon?: boolean;
}

// --- SHARED SUB-MENUS ---
const LEARN_MENU: MenuItem = {
   label: 'Learn',
   id: 'learn',
   type: 'collapse',
   children: [
      { label: 'Academy', route: 'https://academy.musaffa.com/', isExternal: true, hideExternalIcon: true },
      { label: 'Webinars', route: 'https://academy.musaffa.com/videos/past-live-sessions/', isExternal: true, hideExternalIcon: true  },
      { label: 'How To’s', route: 'https://academy.musaffa.com/videos/how-to-videos/', isExternal: true, hideExternalIcon: true  },
      { label: 'Articles', route: 'https://academy.musaffa.com/articles/', isExternal: true, hideExternalIcon: true  },
      { label: 'Investing Mini Courses', route: 'https://academy.musaffa.com/learn/', isExternal: true, hideExternalIcon: true  },
      { label: 'Live 1:1 Courses', route: 'https://academy.musaffa.com/live-courses/', isExternal: true, hideExternalIcon: true  },
   ]
};

const FOR_BUSINESS_MENU: MenuItem = {
   label: 'For Business',
   id: 'for-business',
   route: '/for-business'
};

const MORE_MENU: MenuItem = {
   label: 'More',
   id: 'more',
   type: 'collapse',
   children: [
      { label: 'Pricing', route: '/pricing' },
      { label: 'About Us', route: '/about-us' },
      { label: 'Screening Methodology', route: '/screening-methodology' },
      { label: 'Ambassador Program', route: '/ambassador-program' },
      { label: 'Investor Relations', route: '/investor-relations' },
   ]
};

// --- TOP HEADER NAVIGATION ---
export const HEADER_NAV_ITEMS: MenuItem[] = [
   { label: 'US Investing', route: '/halal-investing-platform' },
   {
      label: 'Global Screening',
      children: [
         { label: 'Halal Stock Screening', route: '/stock-screener' },
         { label: 'Halal ETF Screening', route: '/etf-screener' },
      ],
   },
   LEARN_MENU,
   {
      label: 'Tools',
      children: [
         { label: 'Portfolio Screening', route: '/portfolio-dashboard' },
         { label: 'Purification Calculator', route: '/purification' },
         { label: 'Zakat Calculator', route: '/zakat-calculator' },
      ],
   },
   FOR_BUSINESS_MENU,
   MORE_MENU,
];

// --- SIDEBAR NAVIGATION BUILDER ---
export const getSidebarMenuItems = (isMobile: boolean, portfolioItem: MenuItem): MenuItem[] => {
   const baseLinks: MenuItem[] = [
      { label: 'My Watchlist', route: '/watchlist-lists', icon: 'watchlist', isGuarded: true },
      portfolioItem,
      { 
         label: 'My US Trading Account', 
         id: 'trading', 
         route: 'https://trade.musaffa.com/', 
         isExternal: true,
         icon: 'trading-account' 
      },
      {
         label: 'Screener',
         type: 'section',
         children: [
            { label: 'Halal Stock Screener', route: '/stock-screener', icon: 'stock-screener' },
            { label: 'Halal ETF Screener', route: '/etf-screener', icon: 'etf-screener' }
         ]
      },
      {
         label: 'Research',
         type: 'section',
         children: [
            { label: 'Trending Halal Stocks', route: '/trending-halal-stocks/most_active', icon: 'trending-halal-stocks' },
            { 
               label: 'Halal Stock Collections', 
               id: 'halal-collections',
               icon: 'halal-stock-collections'
            },
            { label: 'Super Investor Portfolios', route: '/super-investor-portfolio/', icon: 'super-investor-portfolios' },
            { label: 'User Curated Collections', route: '/public-lists', icon: 'user-curated-collections' }
         ]
      },
      {
         label: 'Tools',
         type: 'section',
         children: [
            { label: 'Purification Calculator', route: '/purification', icon: 'purification-calculator' },
            { label: 'Zakat Calculator', route: '/zakat-calculator', icon: 'zakat-calculator' }
         ]
      }
   ];

   if (!isMobile) return baseLinks;

   // Mobile Specific Mobile-Menu (Home/Learn/Business/More)
   const mobileHomeMenu: MenuItem = {
      label: 'Home',
      id: 'home-mobile',
      type: 'collapse',
      icon: 'home',
      children: [
         LEARN_MENU,
         FOR_BUSINESS_MENU,
         MORE_MENU
      ]
   };

   return [mobileHomeMenu, ...baseLinks];
};

// --- FOOTER NAVIGATION BUILDER ---
export const getSidebarFooterItems = (isMobile: boolean, actions: { onWhatsNew: () => void, onFeedback: () => void }): MenuItem[] => {
   const items: MenuItem[] = [
      { label: 'Pricing', route: '/pricing', icon: 'pricing' },
      { label: 'What’s New', id: 'whats-new', icon: 'sparkle', action: actions.onWhatsNew },
      { label: 'Got Feedback', id: 'feedback', icon: 'feedback', isGuarded: true, action: actions.onFeedback }
   ];

   if (isMobile) {
      items.push({ label: 'Download Mobile App', isExternal: true, route: 'https://app.musaffa.com/ar0PDlRM2Jb', icon: 'download' });
   }

   return items;
};
